export default "__VITE_ASSET__DAfQcCn4__"